import React from 'react';
import { Outlet } from 'react-router-dom';

import { useLayout } from '@context/Utils';
import { Footer, NavigationHeader } from '@core/index';
import { Loader } from '@utils/Icons/Loader';

export function PublicOnlineTopUpLayout() {
  const { isLoading } = useLayout();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="bg-mint-40 min-dvh-100 d-flex flex-column">
        <NavigationHeader />
        <main className="flex-grow-1">
          <Outlet />
        </main>
        
      </div>
      <Footer />
    </>
  );
}

export default PublicOnlineTopUpLayout;
